import Link from 'next/link'
import { FastlyImage } from '@components/common/image'
import useResolution from '@hooks/useResolution'

const IMAGE_PATH = '/images/reviews-and-testimonials/banner/'

const BannerCard = () => {
  const { isMobileScreen } = useResolution()
  return (
    <div className="pb-12 lg:pb-16 px-5 container mx-auto">
      <Link href={`https://www.codingal.com/register/`} prefetch={false}>
        <a className="mx-auto relative inline-block">
          {!isMobileScreen && (
            <div>
              <FastlyImage
                src={`${IMAGE_PATH}desktop.png`}
                height={339}
                width={1280}
                alt="Review and testimonial banner"
              />
            </div>
          )}
          {isMobileScreen && (
            <div>
              <FastlyImage
                src={`${IMAGE_PATH}mobile-v2.png`}
                height={159}
                width={480}
                alt="Review and testimonial mobile banner"
              />
            </div>
          )}
        </a>
      </Link>
    </div>
  )
}

export default BannerCard
